import { selectize } from '@selectize/selectize'
import { Fancybox } from '@fancyapps/ui'
import { searchSpinner, updateQueryStringParameter, getRexDocuments } from './custom-functions.js'

// selectize all select elements with default settings.
window.selectizeTheWorld = () => {

	jQuery('select').selectize({
		plugins: ['remove_button', 'restore_on_backspace', 'clear_button', 'auto_position'],
		delimiter: ',',
		persist: false,
		create: function (input) {
			return {
				value: input, text: input,
			}
		},
	})
}

// Update the sort order when clicked.
window.changePropertySortOrder = () => {

	const sortOrder = document.getElementById('epl-sort-listings-');

	if (sortOrder) {
		jQuery('#epl-sort-listings-').selectize({
			onChange: function (value, isOnInitialize) {
				if (value !== '') {
					let url = window.location.href;
					let newUrl = updateQueryStringParameter(url, 'sortby', value);
					window.location.replace(newUrl);
				}
			}
		});
	}
}

/**
 * Once the page loads, do our stuff!
 */
document.addEventListener('DOMContentLoaded', function () {

	// Fix for the sort order tool from EPL on property archive pages.
	changePropertySortOrder();

	// Check for submit buttons and add spinner.
	searchSpinner();

	// Enables Selectize on all select elements.
	selectizeTheWorld();


	// Get Fancybox going.
	Fancybox.bind('[data-fancybox]', {})

	// Enable Tooltips for BootStrap 5.3.
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	tooltipTriggerList.forEach(tooltipTriggerEl => new understrap.Tooltip(tooltipTriggerEl))

	// Get the contract link element, and if it exists, load the data when the dropdown is clicked.
	const documentLinks = document.getElementById('contract-links');
	if (documentLinks) {
		documentLinks.addEventListener('show.bs.dropdown', event => {
			console.log('Dropdown shown');
			getRexDocuments(documentLinks.dataset.id)
		});
	}

	// Function to adjust scroll position for anchor links
	function adjustAnchorScroll() {
		const anchor = document.getElementById(window.location.hash.substring(1));
		if (anchor) {
			const offset = 100; // Adjust this value to match the height of your fixed header
			const elementPosition = anchor.getBoundingClientRect().top;
			const offsetPosition = elementPosition + window.pageYOffset - offset;

			window.scrollTo({
				top: offsetPosition,
				behavior: 'smooth'
			});
		}
	}

	// Adjust scroll position on page load if there's an anchor in the URL
	if (window.location.hash) {
		adjustAnchorScroll();
	}

	// Adjust scroll position when navigating to an anchor link
	window.addEventListener('hashchange', adjustAnchorScroll);

	const charLimit = 693;

	document.querySelectorAll(".less-content-wrapper").forEach(wrapper => {
		const contentEl = wrapper.querySelector(".less-content");
		const btn = wrapper.querySelector(".read-more-btn");

		if (!contentEl || !btn) return; // <-- Add this line

		const fullText = contentEl.innerHTML.trim(); // Preserve HTML tags
		const plainText = contentEl.textContent.trim(); // Extract plain text for length comparison

		if (plainText.length <= charLimit) {
			btn.style.display = "none";
			return;
		}

		// Create a trimmed version of the HTML content
		let trimmedText = fullText;
		let currentLength = 0;
		const tempDiv = document.createElement("div");
		tempDiv.innerHTML = fullText;

		// Iterate through child nodes to build the trimmed content
		const trimmedContent = Array.from(tempDiv.childNodes).reduce((acc, node) => {
			if (currentLength >= charLimit) return acc;

			const nodeText = node.textContent || "";
			const remainingLength = charLimit - currentLength;

			if (currentLength + nodeText.length > charLimit) {
				// Trim the text content of this node
				const trimmedNodeText = nodeText.slice(0, remainingLength) + "...";
				const clonedNode = node.cloneNode();
				clonedNode.textContent = trimmedNodeText;
				acc.push(clonedNode);
				currentLength += remainingLength;
			} else {
				// Add the entire node
				acc.push(node.cloneNode(true));
				currentLength += nodeText.length;
			}

			return acc;
		}, []);

		// Set the trimmed content
		tempDiv.innerHTML = "";
		trimmedContent.forEach(node => tempDiv.appendChild(node));
		trimmedText = tempDiv.innerHTML;

		contentEl.setAttribute("data-full", fullText);
		contentEl.setAttribute("data-trimmed", trimmedText);
		contentEl.innerHTML = trimmedText;

		btn.addEventListener("click", () => {
			const isExpanded = wrapper.classList.toggle("expanded");
			contentEl.innerHTML = isExpanded
				? contentEl.getAttribute("data-full")
				: contentEl.getAttribute("data-trimmed");

			btn.textContent = isExpanded ? "Read Less" : "Read More";
		});
	});


	const reviewTitles = document.querySelectorAll('.rcreviews--title');
	if (reviewTitles.length) {
		reviewTitles.forEach(function (title) {
			const text = title.textContent.trim().toLowerCase();
			let label = '';
			if (text.startsWith('buyer')) {
				label = 'BUYER';
			} else if (text.startsWith('seller')) {
				label = 'SELLER';
			}
			if (label) {
				title.innerHTML = `<strong>${label}</strong>`;
			}
		});
	}
});

window.addEventListener('load', adjustBannerHeight);
window.addEventListener('resize', adjustBannerHeight);

function adjustBannerHeight() {
	const banners = document.querySelectorAll('.banner-set-height');

	banners.forEach(banner => {
		const bannerHeight = banner.offsetHeight;
		const viewportHeight = window.innerHeight;

		// Check if the body has the 'single-property' class
		const bodyHasSinglePropertyClass = document.body.classList.contains('single-property');

		// If the body has the 'single-property' class, add 207px to the banner height
		let adjustedHeight = bannerHeight;
		if (bodyHasSinglePropertyClass) {
			adjustedHeight += 167;
		}

		// If the body has the 'single-property' class, set the height to `calc(100vh - 207px)`
		if (bodyHasSinglePropertyClass) {
			if (adjustedHeight > viewportHeight) {
				banner.style.height = `calc(100vh - 217px)`; // Set to `calc(100vh - 207px)` instead of `calc(100vh - 50px)`
			} else {
				banner.style.height = `${adjustedHeight}px`;
			}
		} else {
			// If no 'single-property' class, set the height to `calc(100vh - 50px)`
			if (bannerHeight > viewportHeight) {
				banner.style.height = `calc(100vh - 50px)`;
			} else {
				banner.style.height = `717px`; // Use the original height if it is within the viewport
			}
		}
	});
}

document.addEventListener('DOMContentLoaded', function () {
	const reviewButton = document.querySelector('.rcreviews--btn');

	// Check if the button exists
	if (!reviewButton) {
		return; // Exit the function if the button doesn't exist
	}

	reviewButton.addEventListener('click', function () {
		document.querySelectorAll('.rcreviews--row').forEach(row => {
			// Get all shown reviews inside this row
			const shownReviews = row.querySelectorAll('.rcreviews--shown-review');

			if (shownReviews.length > 0) {
				const lastReview = shownReviews[shownReviews.length - 1];
				const card = lastReview.querySelector('.rcreviews--card');

				if (card) {
					card.classList.toggle('border-white');
					card.classList.toggle('border-bottom');
					card.classList.toggle('border-1');
				}
			}
		});

		// Hide the button by adding the `d-none` class
		document.querySelector('.rcreviews--btn-wrapper').classList.add('d-none');
	});
});